import { GetStaticPropsContext, GetStaticPropsResult } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import CompliancePage from '@/features/services/pages/Compliance'
import { ServicePageProps } from '@/features/services/types'

import { getBlogs } from '@/features/blogs/api/getBlogs'
import { DEFAULT_LOCALE } from '@/lib/localization/constants'

import { REVALIDATE_TIMEOUT } from '@/constants/page'

export async function getStaticProps(
  ctx: GetStaticPropsContext,
): Promise<GetStaticPropsResult<ServicePageProps>> {
  const { locale = DEFAULT_LOCALE } = ctx

  const { blogs } = await getBlogs(
    locale,
    {
      page: 0,
      per: 4,
    },
    4,
  )

  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'services',
        'handout',
        'faqs',
        'landing',
      ])),
      blogs,
    },
    revalidate: REVALIDATE_TIMEOUT,
  }
}

export default CompliancePage
